import { type invertedMessages } from '../utils/messages';

/**
 * TODO: NodeJS upgrade with microfrontend architecture - Move these to environemnt variables once a separate pod will be created for this.
 */
const config = {
  USE_LOCAL_MOCK_API: false,
  /**
   * Don't update below in prodcution. Only in dev. superset url, we are dynamically creating in IspmUtil
   */
  // SUPERSET_URL: '',
  SUPERSET_URL: 'https://superset-intelligence-dev.saviyntcloud.com/login/',
  DASHBOARD_URL: '/intelligence/ispm/dashboard',
  RESET_ENTRY: {
    userQuery: 'Reset chat' as keyof typeof invertedMessages,
    response: 'Sure, How can I help?' as keyof typeof invertedMessages,
  },
  RECENT_CHART_STORAGE: 2,
  RECENT_TABLE_STORAGE: 1,
};

export default config;
